import React from 'react';
import {
  BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ComposedChart, ResponsiveContainer
} from 'recharts';

const data = [
  {
    name: 'FAB SHOP',
    FirstAid: 5,
    PropertyDamage: 3,
    ReportOnly: 2,
    MVA: 2,
    NearMisses: 1,
    Recordable: 1,
    PSI: 1,
    Manhours: 5000
  },
  {
    name: 'FASKEN',
    FirstAid: 1,
    PropertyDamage: 0,
    ReportOnly: 0,
    MVA: 0,
    NearMisses: 0,
    Recordable: 1,
    PSI: 0,
    Manhours: 100000
  },
  {
    name: 'KINETIK',
    FirstAid: 2,
    PropertyDamage: 1,
    ReportOnly: 1,
    MVA: 0,
    NearMisses: 0,
    Recordable: 0,
    PSI: 0,
    Manhours: 180000
  },
  {
    name: 'OXY',
    FirstAid: 3,
    PropertyDamage: 2,
    ReportOnly: 2,
    MVA: 1,
    NearMisses: 0,
    Recordable: 1,
    PSI: 1,
    Manhours: 25000
  },
  {
    name: 'WHITE WATER',
    FirstAid: 0,
    PropertyDamage: 0,
    ReportOnly: 0,
    MVA: 0,
    NearMisses: 0,
    Recordable: 0,
    PSI: 0,
    Manhours: 15000
  },
  {
    name: 'XTO',
    FirstAid: 0,
    PropertyDamage: 0,
    ReportOnly: 0,
    MVA: 0,
    NearMisses: 0,
    Recordable: 0,
    PSI: 0,
    Manhours: 0
  }
];

const IncidentChart = () => {
  return (
    <ResponsiveContainer width="100%" height={400}>
      <ComposedChart data={data}>
        <CartesianGrid stroke="#f5f5f5" />
        <XAxis dataKey="name" angle={-45} textAnchor="end" height={80} />
        <YAxis yAxisId="left" />
        <YAxis yAxisId="right" orientation="right" />
        <Tooltip />
        <Legend />
        
        {/* Stacked Bars */}
        <Bar yAxisId="left" dataKey="FirstAid" stackId="a" fill="#1E90FF" name="First Aid" />
        <Bar yAxisId="left" dataKey="PropertyDamage" stackId="a" fill="#4169E1" name="Property Damage" />
        <Bar yAxisId="left" dataKey="ReportOnly" stackId="a" fill="#6A5ACD" name="Report Only" />
        <Bar yAxisId="left" dataKey="MVA" stackId="a" fill="#8A2BE2" name="MVA" />
        <Bar yAxisId="left" dataKey="NearMisses" stackId="a" fill="#DA70D6" name="Near Misses" />
        <Bar yAxisId="left" dataKey="Recordable" stackId="a" fill="#FF69B4" name="Recordable" />
        <Bar yAxisId="left" dataKey="PSI" stackId="a" fill="#FF6347" name="PSI" />
        
        {/* Line for Manhours */}
        <Line
          yAxisId="right"
          type="monotone"
          dataKey="Manhours"
          stroke="#FF0000"
          strokeWidth={2}
          dot={{ stroke: '#FF0000', strokeWidth: 2, fill: '#fff', r: 5 }}
          name="Manhours"
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default IncidentChart;
